import Welcome from '@ViewsDashboard/Welcome/Welcome';
// 管理员视图
import ViewsDashboard from '@ViewsDashboard/ViewsDashboard';
// 概况 团队统计
import MySummary1 from '@ViewsDashboard/Pandect/MySummary/MySummary1';
// 概况 个人及直属会员统计
import MySummary from '@ViewsDashboard/Pandect/MySummary/MySummary';
// 用户信息列表
import UserList from '@ViewsDashboard/User/UserList/UserList';
// 代理信息列表
import AgentList from '@ViewsDashboard/Agent/AgentList/AgentList';
// 会员购彩列表
import MemberPurchase from '@ViewsDashboard/Agent/memberPurchase/MemberPurchaseList';
// 我的返佣列表
import MyRakeBackList from '@ViewsDashboard/Statistic/MyRakeBack/MyRakeBackList';
// 充值记录
import WalletHistoryList from '@ViewsDashboard/Statistic/WalletHistory/WalletHistoryList';
// 提现记录
import WalletHistoryList1 from '@ViewsDashboard/Statistic/WalletHistory/WalletHistoryList1';
// 会员赠送列表
import GiveawayLog from '@ViewsDashboard/Statistic/GiveawayLog/GiveawayLogList';
// 代充列表
import GeneraCharge from '@ViewsDashboard/Statistic/GeneraCharge/GeneraChargeList';
// 转充列表
import TurnToCharge from '@ViewsDashboard/Statistic/TurnToCharge/TurnToChargeList';
// 代理盈亏
// import AgentProfit from '@ViewsDashboard/Statistic/AgentProfit/AgentProfitList';


// 修改密码
import SetPassword from '@ViewsDashboard/Setting/SetPassword/SetPassword';

import global_store from '@store/Common/GlobalStore';

let authority_map = global_store.authority_map;
let nav_data = [
  {
    name: '管理首页',
    icon: '',
    path: '/',
    exact: false,
    authority: 'admin',
    role_array: [],
    component: ViewsDashboard,
    is_Nav: true,
    children: [
      {
        name: '数据统计',
        icon: 'home',
        path: '/pandect',
        authority: 'admin',
        role_array: [],
        is_Nav: true,
        redirect: '/my-summary/:id/:username',
        children: [
          {
            name: '直属会员统计(包括自己)',
            icon: 'list',
            path: '/my-summary/:id/:username',
            component: MySummary,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          {
            name: '团队统计(包括所有)',
            icon: 'list',
            path: '/my-summary1/:id/:username',
            component: MySummary1,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
        ]
      },
      {
        name: '会员管理',
        icon: 'user',
        path: '/user',
        authority: 'admin',
        role_array: [],
        is_Nav: true,
        redirect: '/user-list',
        children: [
          {
            name: '会员列表',
            icon: 'list',
            path: '/user-list/:type/:id/:username',
            component: UserList,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          {
            name: '会员购彩列表',
            icon: 'list',
            path: '/memberpurchaselist/:type/:id/:username',
            component: MemberPurchase,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
        ]
      },
      {
        name: '代理管理',
        icon: 'share-alt',
        path: '/agent',
        authority: 'admin',
        role_array: [],
        is_Nav: true,
        redirect: '/agent-list',
        children: [
          {
            name: '代理信息列表',
            icon: 'list',
            path: '/agent-list/:id/:username',
            component: AgentList,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
        ]
      },
      {
        name: '统计',
        icon: 'pie-chart',
        path: '/me',
        authority: 'admin',
        role_array: [],
        is_Nav: true,
        redirect: '/statistic',
        children: [
          {
            name: '投注返佣记录',
            icon: 'list',
            path: '/myrakeback',
            component: MyRakeBackList,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          {
            name: '充值记录',
            icon: 'list',
            path: '/topUp',
            component: WalletHistoryList,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          {
            name: '提现记录',
            icon: 'list',
            path: '/wallethistory',
            component: WalletHistoryList1,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          {
            name: '赠送列表',
            icon: 'list',
            path: '/giveawaylist',
            component: GiveawayLog,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          {
            name: '代充列表',
            icon: 'list',
            path: '/genecharge',
            component: GeneraCharge,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          {
            name: '转充列表',
            icon: 'list',
            path: '/turntocharge',
            component: TurnToCharge,
            exact: false,
            authority: 'admin',
            role_array: [],
            is_Nav: true,
          },
          // {
          //   name: '盈亏列表',
          //   icon: 'list',
          //   path: '/agentprofit',
          //   component: AgentProfit,
          //   exact: false,
          //   authority: 'admin',
          //   role_array: [],
          //   is_Nav: true,
          // },
        ]
      },
      {
        name: '设置',
        icon: 'setting',
        path: '/setting',
        authority: 'admin',
        role_array: [ 'user-setting' ],
        is_Nav: true,
        redirect: '/set-password',
        children: [
          {
            name: '修改密码',
            icon: 'SetPassword',
            path: '/set-password',
            component: SetPassword,
            exact: true,
            authority: 'admin',
            role_array: [ 'user-setting' ],
            is_Nav: true,
          },
          {
            name: '欢迎页',
            path: '/welcome',
            authority: 'admin',
            role_array: [ 'user-setting' ],
            is_Nav: false,
            component: Welcome
          }
        ]
      }
    ]
  }
];

// console.log(nav_data)

/**
 * 扁平化嵌套数据结构，多维数据结构转成 一维
 * @param {*} menu 需要扁平化的数据结构
 * @param {*} parent 父节点
 */
function flatNav(menu, parent = {}) {
  let result_arr = [];
  let result_path_map = new Map();
  let result_name_map = new Map();

  menu.forEach((item) => {
    let { path, children, name, ...res } = item;

    if(Array.isArray(children) && children.length > 0) {
      children = children.map((child) => {
        let {path, ...res} = child;
        return {
          path,
          ...res
        }
      });

      let nest_result = flatNav(item.children, item);
      let nest_result_arr = nest_result.result_arr;
      let nest_result_path_map = nest_result.result_path_map;
      let nest_result_name_map = nest_result.result_name_map;

      result_arr.push(...nest_result_arr);
      result_path_map = new Map([...result_path_map, ...nest_result_path_map]);
      result_name_map = new Map([...result_name_map, ...nest_result_name_map]);
    }

    result_arr.push({
      name,
      path,
      children,
      parent: parent,
      ...res,
    });

    let simplePath = path;
    let index = path.indexOf(':');
    if (index != -1)
    {
      simplePath = path.slice(0,index -1);
    }

    result_path_map.set(simplePath, {
      name,
      path,
      children,
      parent: parent,
      ...res,
    });

    result_name_map.set(name, {
      name,
      path,
      children,
      parent: parent,
      ...res,
    })
  });
  // console.log(result_arr, result_path_map, result_name_map);
  return {
    result_arr,
    result_path_map,
    result_name_map
  };
};

const {
  result_path_map: nav_path_map,
  result_name_map: nav_name_map,
  result_arr: nav_arr
} = flatNav(nav_data);

// console.log(nav_path_map);
// console.log(nav_name_map);
// console.log(nav_arr);

/**
 * 根据 match_path 获取 nav_data 节点
 * @param {String} match_path react-router 匹配出的 match_path
 */
function getNavNodeByMatchPath(match_path) {
  let node = nav_path_map.get(match_path);
  // console.log("333333",match_path)
  // console.log("ssssss",nav_path_map)
  // console.log("444444",node)
  // 返回新的数据引用
  return node;
};

function getNavNodeByName(name) {
  let node = nav_name_map.get(name);
  return node;
};

// console.log("nav_arr: ", nav_arr);
// console.log("nav_path_map: ", nav_path_map);

export {
  nav_path_map,
  nav_name_map,
  nav_arr,
  nav_data,
  getNavNodeByName,
  getNavNodeByMatchPath
};



// WEBPACK FOOTER //
// ./src/common/NavConfig.js